import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Box, Grid, Card, CardContent, CardActions, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';
import BlockEditor from '../editor/BlockEditor';
import AceEditor from "react-ace";

const LearnScreen = props => {
    const { screen_id, show_script = true } = useParams()
    const [blockId, setBlockId] = React.useState(null)
    const [value, setValue] = useState('');
    const [loadingScript, setLoadingScript] = useState(false);
    
    useEffect(() => {
        client.request_get(`/screen/${screen_id}`).then(res => {
            if (res && res.block_list) {
                setBlockId(res.block_list[0].block_id)
                setValue(res.javascript_on_create)
            } else
                ;//alert(JSON.stringify(res))
        })
    }, [])

    const handleChange = (code) => {
        setValue(code)
    }

    const handleSaveScreenSource = () => {
        setLoadingScript(true)
        client.request_post(`/api/learning/screen/${screen_id}`, {
            javascript_on_create: value
        }).then(res => {
            setLoadingScript(false)
        })
    }

    return (
        <Box m={0}>
        <Grid container spacing={2} fullWidth >
            <Grid item xs={12}>
                <Box>
                    <BlockEditor id={blockId} learning={true} />
                </Box>
            </Grid>

            {show_script && <Grid item xs={12}>
                <Box m={1}>
                    <Button startIcon={loadingScript && <CircularProgress size={24}/>} 
                        disabled={loadingScript}
                        variant='outlined' onClick={handleSaveScreenSource}>스크린 자바스크립트 저장</Button>
                </Box>
                <Box style={{ overflow: 'auto' }}>
                    <AceEditor
                        width={'100%'}
                        height={props.height ? props.height : '350px'}
                        placeholder={'스크린 자바스크립트'}
                        mode="javascript"
                        theme="github"
                        name="blah2"
                        onChange={newValue => { handleChange(newValue) }}
                        fontSize={14}
                        showPrintMargin={true}
                        showGutter={true}
                        highlightActiveLine={true}
                        value={value}
                        setOptions={{
                            enableBasicAutocompletion: false,
                            enableLiveAutocompletion: false,
                            enableSnippets: false,
                            showLineNumbers: true,
                            tabSize: 2,
                        }} />
                </Box>
            </Grid>}
        </Grid>
        </Box>
    );
};

export default LearnScreen;
